import image1 from '../images/1.png';
import image2 from '../images/2.png';
import image3 from '../images/3.png';
import image4 from '../images/4.png';
import image5 from '../images/5.png';
import image6 from '../images/6.png';
import image7 from '../images/7.png';
import image8 from '../images/8.png';
import image9 from '../images/9.png';
import image10 from '../images/10.png';
import image11 from '../images/11.png';
import image12 from '../images/12.png';

export const Service_list_bang = [
	{
		id: 1,
		title: 'Washing Machine',
		desc: 'Is your washing machine not spinning, leaking, or showing error codes? We repair all types – front load, top load, semi-automatic, & fully automatic machines.',
		img: image1,
	},
	{
		id: 2,
		title: 'Refrigerator',
		desc: 'A faulty refrigerator can disrupt your daily life. We offer same-day refrigerator repairs for single-door, double-door, and side-by-side fridges.',
		img: image2,
	},
	{
		id: 3,
		title: 'Air Conditioner (AC)',
		desc: 'Beat Bangalore & Dhanbad’s heat with our expert AC repair services. Whether it’s split AC or window AC, we ensure efficient cooling and smooth performance.',
		img: image3,
	},
	{
		id: 4,
		title: 'Microwave Oven',
		desc: 'Don’t let a faulty microwave disrupt your kitchen routine. We repair solo, grill, and convection microwaves efficiently. Our technicians can fix it quickly and safely.',
		img: image4,
	},
	{
		id: 5,
		title: 'TV',
		desc: 'Facing issues with your TV? Whether it’s an LED, LCD, or Plasma TV, we provide expert repairs to resolve display, sound, or connectivity problems promptly.',
		img: image5,
	},
	{
		id: 6,
		title: 'Cooler',
		desc: 'Keep cool during the summer with our reliable cooler repair services. From desert coolers to personal coolers, we fix leaks, motor issues, and more.',
		img: image6,
	},
	{
		id: 7,
		title: 'Dish Washer',
		desc: 'Don’t let a faulty dishwasher pile up your chores. We repair dishwashers of all brands, tackling drainage issues, motor problems, and cleaning performance for hassle-free use.',
		img: image7,
	},
	{
		id: 8,
		title: 'Water Purifier',
		desc: 'Ensure safe drinking water with our water purifier repair services. We fix RO, UV, and UF purifiers, addressing leaks, filter changes, and performance issues.',
		img: image8,
	},
	{
		id: 9,
		title: 'UPS',
		desc: 'Keep your devices powered with our UPS repair services. We fix all types of UPS systems, ensuring uninterrupted power supply and battery performance.',
		img: image9,
	},
	{
		id: 10,
		title: 'Solar water heater',
		desc: 'Solar water heaters are energy-efficient systems that use sunlight to heat water for domestic use. They consist of solar panels, a storage tank, and a circulation system.',
		img: image10,
	},
	{
		id: 11,
		title: 'Chimney',
		desc: 'Keep your kitchen smoke-free with our chimney repair services. We fix all types of chimneys, ensuring efficient ventilation and odor removal.',
		img: image11,
	},

	{
		id: 12,
		title: 'Water Heater',
		desc: 'Gas and electric water heaters are essential appliances for heating water. Gas heaters use natural gas or propane, while electric heaters rely on electricity. Both types provide hot water for various household needs.',
		img: image12,
	},
];
